<template>
  <component
    :is="rootComponent"
    class="flex text-n-600 dark:text-n-0 p-4 border rounded dark:border-n-600 dark:bg-n-700 border-n-100 bg-n-10 relative min-w-12 w-full h-full"
    :class="[
      $attrs.disabled ? 'pointer-events-none cursor-not-allowed opacity-30' : 'cursor-pointer',
      'text-base',
      model === value ? 'dark:border-v-300 border-v-500' : '',
      `border-${selectedBorderWidth}`
    ]"
  >
    <input
      type="radio"
      v-bind="$attrs"
      v-model="model"
      :value="value"
      :name="name"
      :disabled="$attrs.disabled !== undefined && $attrs.disabled !== false"
      :class="[
        'absolute top-4 right-4',
        'appearance-none m-0 rounded-full border border-1 dark:border-v-300 border-v-500 grid place-items-center transition-transform',
        'before:rounded-full before:scale-0 dark:before:bg-v-300 before:bg-v-500 before:checked:scale-100',
        radioSizeClasses
      ]"
    />
    <slot></slot>
  </component>
</template>

<script setup lang="ts">
import { computed, type InputHTMLAttributes } from 'vue'

type Props = {
  /** Name of the radio group */
  name: string
  /** The value of the radio button */
  value: string | number | boolean

  rootComponent?: string
  selectedBorderWidth?: number
  radioSize?: 'small' | 'medium'
} & /* @vue-ignore */ InputHTMLAttributes

const props = withDefaults(defineProps<Props>(), {
  rootComponent: 'label',
  selectedBorderWidth: 1,
  radioSize: 'small'
})

const model = defineModel<string | number | boolean>()

const radioSizeClasses = computed<string>(() => {
  return props.radioSize === 'medium'
    ? 'h-[1.375rem] w-[1.375rem] before:h-3 before:w-3'
    : 'h-4 w-4 before:h-[0.375rem] before:w-[0.375rem]'
})
</script>
